import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { endpoints, environment } from '@environment';
import {
  OnboardingInitializeRequest,
  OnboardingInitializeResponse,
} from '@core/models';
import { Observable } from 'rxjs';
import { suppressGlobalErrorFeedback } from '@core/interceptors';

@Injectable({ providedIn: 'root' })
export class OnboardingService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.onboarding}`;

  initialize(
    request: OnboardingInitializeRequest = {},
    suppressGlobalFeedback = false
  ): Observable<OnboardingInitializeResponse> {
    return this.http.post<OnboardingInitializeResponse>(
      `${this.baseUrl}/initialize`,
      request,
      suppressGlobalFeedback ? { context: suppressGlobalErrorFeedback() } : undefined
    );
  }
}
